import * as Sentry from '@sentry/vue'

import { Mode } from '@/types/environment'

import { getSentryIntegrations, isSentryEnabled } from '../utils/sentryUtils'

/* Плагин для прокидывания sentry в контекст приложения */
export default defineNuxtPlugin({
  name: 'initSentry',
  setup({ vueApp }) {
    const { SENTRY_DSN, MODE } = useRuntimeConfig().public
    const router = useRouter()

    /* В зависимости от прода, выставляем нужное значение */
    const sampleRate = MODE === Mode.PROD ? 0.5 : 0.2

    /* Инициализация Sentry */
    Sentry.init({
      app: vueApp,
      dsn: SENTRY_DSN as string,
      enabled: isSentryEnabled(MODE as string),
      environment: MODE as Mode,

      tracesSampleRate: sampleRate,

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })

    /* Lazy-load загрузка sentry плагинов */
    getSentryIntegrations({ router })

    return {
      provide: {
        sentryCaptureException: Sentry.captureException,
      },
    }
  },
})
